<template>
  <v-autocomplete
    outlined
    hide-details
    return-object
    no-filter
    hide-selected
    hide-no-data
    multiple
    chips
    deletable-chips
    small-chips
    item-text="nome"
    item-value="id"
    label="Cidades"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    @change="onChange"
    v-bind="$attrs"
  >
    <template v-slot:item="item">
      <v-list-item-content>
        <v-list-item-title>
          ({{ item.item.estado.sigla }}) {{ item.item.nome  }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import MunicipioService from '@/api/municipio-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: [Object, Array],
    ufs: Array,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    searchData(val) {
      const searchValue = val ? val.toLowerCase() : '';

      this.loading = true;

      let query = `(nome like "%${searchValue}%")`;
      if (this.ufs && this.ufs.length) {
        const ids = this.ufs.map(uf => uf.id).filter(id => !!id);
        query = `${query} and (estado in (${ids.join(', ')}))`;
      }
      MunicipioService.getMunicipiosPage({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query,
      })
        .then((response) => {
          if (this.value) {
            this.items = [...response.data.content, ...this.value];
            return;
          }
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchData, 1000);
    if (this.value) {
      this.items = [...this.items, ...this.value];
    }
  },
};
</script>
